var map = {
	"./2022-01-28-linked-in-trackers-policy.md": 258,
	"./2022-09-06-twitter-copyright-claims-policy.md": 259,
	"./2022-09-16-Tiktok-Trackers-Policy.md": 260,
	"./2022-10-07-TikTok-Age-Limit-Streaming.md": 261,
	"./2022-12-02-twitch-privacy-policy.md": 262,
	"./2022-12-09-youtube-community-guidelines.md": 263,
	"./2022-12-15-twitter-community-guidelines.md": 264,
	"./2023-01-19-twitter-developer-terms.md": 265,
	"./2023-01-21-instagram-developer-terms.md": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;